import Alpine from "alpinejs";

class VimeoPlayerAPI {
    static jsIsLoading = false;
    static jsIsLoaded = false;

    static loadVimeoApiScriptOnce() {
        if (VimeoPlayerAPI.jsIsLoading) return;
        VimeoPlayerAPI.jsIsLoading = true;

        // load scripts delayed to not block critical path
        window.addEventListener('load', () => {
            window.CookieConsentManager.onHasConsent('vimeo', () => {
                setTimeout(() => {
                    let tag = document.createElement('script');
                    let firstScriptTag = document.getElementsByTagName('script')[0];

                    tag.src = 'https://player.vimeo.com/api/player.js';
                    tag.onload = () => VimeoPlayerAPI.jsIsLoaded = true;
                    if (firstScriptTag) {
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    } else {
                        document.head.append(tag);
                    }
                }, 300);
            });
        });
    }
}

const inNeosBackend = window.name === 'neos-content-main';

Alpine.data('vimeoPlayer', (config) => ({
    config: config,
    overlayVisible: true,
    showFallbackPoster: inNeosBackend ? !config.hasPoster : false,
    posterAlternativeText: config.posterAlternativeText,
    hasConsent: window.CookieConsentManager.hasConsent('vimeo') || inNeosBackend,
    player: null,

    init() {
        VimeoPlayerAPI.loadVimeoApiScriptOnce();

        window.CookieConsentManager.onHasConsent('vimeo', () => {
            this.hasConsent = true;
            this.showFallbackPoster = !this.config.hasPoster;
            if (!config.posterAlternativeText) {
                fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + this.config.id)
                    .then(response => response.json())
                    .then(data => {
                        this.$effect(() => {
                            this.posterAlternativeText = data.title;
                        });
                    })
                    .catch(error => null);
            }
        });
    },

    startPlayingOnReady() {
        window.CookieConsentManager.onHasConsent('vimeo', () => {
            this.startPlayerOnReady();
        });
    },

    startPlayerOnReady() {
        if (!VimeoPlayerAPI.jsIsLoaded || !window.Vimeo) {
            setTimeout(() => this.startPlayerOnReady(), 100);
            return;
        }

        if (this.player) {
            this.player.play();
            this.setState('playing');
        } else {
            this.setState('initialised');
            this.player = this.createPlayer();
        }
        this.$refs.iframe.focus();
    },

    createPlayer() {
        const options = {
            id: this.config.id,
            width: '100%',
            height: '100%',
            responsive: true,
            autoplay: true,
            controls: true,
            playsinline: true
        };

        const player = new Vimeo.Player(this.$refs.iframe, options);

        player.on('play', () => {
            this.setState('playing');
        });

        player.on('pause', () => {
            this.setState('paused');
        });

        player.on('ended', () => {
            this.setState('ended');
        });

        player.on('bufferstart', () => {
            this.setState('buffering');
        });

        player.on('bufferend', () => {
            this.setState('playing');
        });

        return player;
    },

    setState(state) {
        this.overlayVisible = {
            initialised: false,
            unstarted: true,
            ended: true,
            playing: false,
            paused: false,
            buffering: false,
            cued: true,
        }[state];
    },
}));
